import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { PayStyleSc } from "./index.sc";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks";
import { getAllEmployeeDetails } from "../../api/HRDashboard/getAllEmployeeDetails";
function Index() {
  const navigate = useNavigate();
  const auth = useAuthContext();
  const [allDetails, setAllDetails] = useState<any>([]);
  const fetchAllEmployeeDetails = async () => {
    await getAllEmployeeDetails(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setAllDetails(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllEmployeeDetails();
  }, []);
  return (
    <PayStyleSc>
      <div className="admin-leave-conatiner">
        <div className="query-conatiner-list">
            <table>
              <tr>
                <th className="heading">S.no</th>
                <th className="heading">Name</th>
                <th className="heading">Employee Id</th>
              </tr>
              {allDetails?.map((data: any, idx: any) => {
                return (
                  <>
                    <tr key={idx} onClick={() => navigate(`${data?.org_user_id}?employeeId=${data?.employee_id}`)}>
                      <td>{idx + 1}</td>
                      <td>{data?.Name}</td>
                      <td>{data?.employee_id}</td>
                    </tr>
                  </>
                );
              })}
            </table>
          </div>
      </div>
    </PayStyleSc>
  );
}

export default Index;
